module.exports = __webpack_public_path__ + "static/media/automat.58b5e668.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/automat.png
// module id = 479
// module chunks = 0